<!-- Progress dashboard starts -->
<div class="page-container">
  <div class="page-heading">
    <!-- Search + filter row (dropdown to the RIGHT of search, both right-aligned) -->
    <!-- Top row: RIGHT-aligned, dropdown LEFT of search -->
    <div class="d-flex align-items-center justify-content-end gap-0">
      <!-- Dropdown (left of search) -->
      @if (hasInverters) {
        <select class="form-select form-select-sm w-auto"
          (change)="onLayerChange($event.target.value)">
          <option value="all" [selected]="layerFilter === 'all'">{{'planner.projectDashboard.all' | translate}}</option>
          <option value="frames" [selected]="layerFilter === 'frames'">{{'planner.projectDashboard.frame' | translate}}</option>
          <option value="inverters" [selected]="layerFilter === 'inverters'">{{'planner.projectDashboard.inverter' | translate}}</option>
        </select>
      }

      <!-- Search (far right) -->
      <div style="width: 290px; max-width: 100%;">
        <app-search (onChange)="onSearchChange($event)" (onClick)="onSearchClick($event)"
          (onLocationClick)="onSearchLocationClick($event)" [strictSearch]="false" [workOrders]="workOrders"
          [inverters]="inverters" [type3WorkOrders]="type3Workorders" [powerLineWorkOrders]="powerLineWorkOrders">
        </app-search>
      </div>
    </div>

    <h3>
      <img class="nav-icon" src="assets/icons/list_alt_black_24dp.svg">
      <span class="page-title">{{'sideNavigation.titleDashboard' | translate}}</span>
    </h3>
    <div class="d-flex flex-wrap">
      <span class="blue-text me-1">{{'planner.projectDashboard.all' | translate}}</span>
      <div class="d-flex align-items-center me-2">
        <div class="dot" [ngStyle]="{'background-color': interruptedColor}"></div>
        {{'basic.interrupted' | translate}}
      </div>
      <div class="d-flex align-items-center me-2">
        <div class="dot" style="background-color: white; border: 1px solid red"></div>
        {{'basic.deviation' | translate}}
      </div>
      @if (checkLength(allStates.states, 1) > 0) {
        <div class="w-100"></div>
        <div class="blue-text me-1">
          @if (customerId === 2) {
            <span>String</span>
          }
          @if (customerId !== 2) {
            <span>{{'planner.projectDashboard.frame' | translate}}</span>
          }
        </div>
        @for (status of allStates.states| filterStatesByType: 1; track $index) {
          <div class="d-flex align-items-center me-2">
            <div class="dot" [ngStyle]="{'background-color': status.color}"></div>
            {{ status.definition }}
          </div>
        }
      }
      @if (checkLength(allStates.states, 2) > 0) {
        <div class="w-100"></div>
        <div class="blue-text me-1">{{'planner.projectDashboard.inverter' | translate}}</div>
        @for (status of allStates.states| filterStatesByType: 2; track $index) {
          <div class="d-flex align-items-center me-2">
            <div class="dot" [ngStyle]="{'background-color': status.color}"></div>
            {{ status.definition }}
          </div>
        }
      }
      @if (checkLength(allStates.states, 3) > 0) {
        <div class="w-100"></div>
        <div class="blue-text me-1">Frames(checkup)</div>
        @for (status of allStates.states| filterStatesByType: 3; track $index) {
          <div class="d-flex align-items-center me-2">
            <div class="dot" [ngStyle]="{'background-color': status.color}"></div>
            {{ status.definition }}
          </div>
        }
      }
      @if (checkLength(allStates.states, 4) > 0) {
        <div class="w-100"></div>
        <div class="blue-text me-1">Frames(checkup)</div>
        @for (status of allStates.states | filterStatesByType: 4; track $index) {
          <div class="d-flex align-items-center me-2">
            <div class="dot" [ngStyle]="{'background-color': status.color}"></div>
            {{ status.definition }}
          </div>
        }
      }
    </div>
    @if (hasInverters || hasPowerlines) {
      <div>
        <app-multi-select-search [workOrders]="workOrders" [inverters]="inverters" [type3WorkOrders]="type3Workorders"
          [powerLineWorkOrders]="powerLineWorkOrders" [reports]="reports" [states]="allStates.states"
          [selectedMode]="multiSelectSearchModes.REPORTED_ANY" (onChange)="filterWorkOrders($event)"
          [selectedTypeId]="selectedTypeId">
        </app-multi-select-search>
      </div>
    }
  </div>
  <div class="page-content">

    <div class="map-height">
      <div id="mapProject" class="map-container structure-child">
        <div class="map-control-bar">
          @if (customerId == customerIds.POWERLINES) {
            <app-checkbox text="Group" (isChecked)="togglePowerLineGroups()">
            </app-checkbox>
          }
        </div>
      </div>
    </div>

    @if (pageLoading) {
      <div class="justify-content-center w-100 d-flex">
        @if (pageLoading) {
          <load-spinner></load-spinner>
        }
      </div>
    }
    @if (!pageLoading) {
      <section class="section">
        <h4>{{'planner.projectDashboard.titleStages' | translate}}</h4>
        @for (state of getSortedStates(); track $index) {
          @if (!state.hidden) {
            <div class="card shadow-sm state-class p-3">
              <hr>
                <h5><span class="dot" [ngStyle]="{'background-color': state.color}"></span>
                {{state.definition}} -
                @if (state.type === 1) {
                  <span class="blue-text">
                    @if (customerId === 2) {
                      <span>String</span>
                    }
                    @if (customerId !== 2) {
                      <span>{{'planner.projectDashboard.frame' | translate}}</span>
                    }
                  </span>
                }
                @if (state.type === 2) {
                  <span class="blue-text">{{'planner.projectDashboard.inverter' | translate}}</span>
                }
                @if (state.type === 3) {
                  <span class="blue-text">Checkup</span>
                }
              </h5>
              <div class="fw-bold mb-2">
                @if (state.type !== 3) {
                  <span>{{'planner.projectDashboard.workorders' | translate }}</span>
                }
                @if (state.type === 3) {
                  <span>{{'planner.projectDashboard.workordersHere' | translate }}</span>
                }
                : {{state.workorders.amount}}
              </div>
              <div class="row">
                @if (state.type !== 3) {
                  <div class="col-4">
                    <h4>{{'planner.projectDashboard.today' | translate}}</h4>
                    <div>{{'basic.done' | translate }}:
                      <span class="green-text">{{state.workorders.todaydone}}/{{ state.workorders.todaytotal}}</span>
                    </div>
                    <div>{{'planner.projectDashboard.interrupted' | translate }}:
                      <span
                      [ngClass]="state.workorders.todayinterrupted > 0 ? 'red-text' : '' ">{{state.workorders.todayinterrupted}}</span>
                    </div>
                  </div>
                }
                @if (state.type !== 3) {
                  <div class="col-4">
                    <h4>{{'planner.projectDashboard.thisWeek' | translate}}</h4>
                    <div>{{'basic.done' | translate }}:
                      <span class="green-text">{{state.workorders.weekdone}}/{{state.workorders.weektotal}}</span>
                    </div>
                    <div>{{'planner.projectDashboard.interrupted' | translate }}:
                      <span
                      [ngClass]="state.workorders.weekinterrupted > 0 ? 'red-text' : '' ">{{state.workorders.weekinterrupted}}</span>
                    </div>
                  </div>
                }
                <div class="col-4">
                  <h4>{{'planner.projectDashboard.wholeProject' | translate}}</h4>
                  <div>{{'basic.done' | translate }}:
                    <span class="green-text">
                      @if (state.type !== 3) {
                        <span>{{state.workorders.totaldone}}</span>
                      }
                      @if (state.type === 3) {
                        <span>{{getDoneAmount(state)}}</span>
                      }
                    / {{getAmount(state)}}</span>
                  </div>
                  @if (state.type !== 3) {
                    <div>
                      {{'planner.projectDashboard.interrupted' | translate }}: <span
                    [ngClass]="state.workorders.totalinterrupted > 0 ? 'red-text' : '' ">{{state.workorders.totalinterrupted}}</span>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      }
      @for (remarkState of getOnlyRemarkState(customerId === customerIds.POWERLINES
        ? allStates.powerlineStates
        : allStates.states); track $index) {
        <div class="card shadow-sm state-class p-3">
          <hr>
            <h5><span class="dot" [ngStyle]="{'background-color': remarkState.color}"></span>
            {{remarkState.definition}}
          </h5>
          <div class="row">
            <div class="col-4">
              <h4>{{'planner.projectDashboard.today' | translate}}</h4>
              <div>{{'basic.done' | translate }}:
                <span class="green-text">{{remarkState.workorders.todaydone}}</span>
              </div>
            </div>
            <div class="col-4">
              <h4>{{'planner.projectDashboard.thisWeek' | translate}}</h4>
              <div>{{'basic.done' | translate }}:
                <span class="green-text">{{remarkState.workorders.weekdone}}</span>
              </div>
            </div>
            <div class="col-4">
              <h4>{{'planner.projectDashboard.wholeProject' | translate}}</h4>
              <div>{{'basic.done' | translate }}:
                <span class="green-text">
                  <span>{{remarkState.workorders.totaldone}}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      }
    </section>
  }
  @if (showSidebar) {
    <div class="rightsidebar">
      <div class="sidebarcontent">
        <img src="assets/icons/close_red_24dp.svg" class="close-btn" (click)="closeSidebar()" />
        @if (selectedMarker.identifier) {
          <h2>
            @if (customerId === 2 && selectedMarker.transformer) {
              <span>{{ selectedMarker.transformer }} -
                {{selectedMarker.inverter}}@if (selectedMarker.circuit) {
                <span> - {{selectedMarker.circuit}}</span>
              }</span>
            }
            @if (customerId === 2 && !selectedMarker.transformer) {
              <span>{{selectedMarker.identifier}}</span>
            }
            @if (customerId === 3) {
              <span>{{selectedMarker.identifier}}<br></span>
            }
            @if (customerId === 4) {
              <span>{{selectedMarker.identifier}}</span>
            }
            @if (customerId !== 2 && customerId !== 4) {
              <span>{{selectedMarker.id}}</span>
            }
          </h2>
        }
        @if (!selectedMarker.identifier && selectedMarker.inverter) {
          <h2>{{ selectedMarker.transformer }} -
          {{selectedMarker.inverter}}</h2>
        }
        @if (selectedMarker.status_id) {
          <div>{{ 'planner.projectDashboard.currentPhase' | translate }}:
          {{getStatusDefinition()}}</div>
        }
        @if (selectedMarker.images) {
          <div>
            @for (img of selectedMarker.images; track $index) {
              <img src="{{img.url}}" alt="{{img.title}}" class="thumbnail"
                (click)="selectedImage = img.url" />
            }
          </div>
        }
        <hr>
          <h4>{{ 'planner.projectDashboard.reports' | translate }} (
            @if (selectedMarker.images) {
              <span>{{selectedMarker.imagecount}}</span>
            }
            @if (!selectedMarker.images) {
              <span>0</span>
            }
            )
          </h4>
          @for (state of selectedStatuses; track $index) {
            @if (!state.hidden) {
              <div>
                <span class="dot" [ngStyle]="{'background-color': state.color}"></span>{{ state.definition }}
                @for (report of state.reports; track $index) {
                  <div>
                    <div>
                      <span class="blue-text">{{ formatReportDateTime(report.created) }}</span>
                      @if (report.notes) {
                        <br>
                        }
                        @if (report.notes) {
                          <span class="text-break"><img class="person-icon"
                          src="assets/icons/comment_24dp_blue.svg"> {{ report.notes }}</span>
                        }
                        <br>
                          <img class="person-icon" src="assets/icons/person_blue_24dp.svg"> {{report.firstname}}
                          {{report.lastname}}
                        </div>
                      </div>
                    }
                    <div>
                      <label class="cursor-pointer" (click)="state.show = !state.show">{{ 'planner.projectDashboard.images' |
                      translate }} ({{ selectedMarker?.statuses?.[state.id]?.count || 0 }})</label>
                      <input class="cursor-pointer" type="radio" [checked]="state.show" (click)="state.show = !state.show">
                    </div>
                    @if (selectedMarker?.statuses?.[state.id]?.images && state.show) {
                      <div class="panel">
                        @for (img of selectedMarker.statuses[state.id].images; track $index) {
                          <img src="{{img.url}}" alt="{{img.title}}"
                            class="thumbnail" (click)="selectedImage = img.url" />
                        }
                      </div>
                    }
                    <hr>
                    </div>
                  }
                }
              </div>
            </div>
          }

          @if (showBaseSidebar) {
            <div class="rightsidebar base-sidebar">
              <div class="sidebarcontent">
                <img src="assets/icons/close_red_24dp.svg" class="close-btn" (click)="closeSidebar()" />
                <h2 class="title">{{ 'planner.projectDashboard.baseLog' | translate }}</h2>
                <div>
                  <h2 class="identifier">{{ selectedBase?.id }}. {{ selectedBase?.identifier }}</h2>
                  @if (!selectedBaseReports?.length) {
                    <h4 class="no-reports">
                      {{ 'planner.projectDashboard.noReportsYet' | translate }}
                    </h4>
                  }
                  @for (report of selectedBaseReports; track $index) {
                    <div class="report">
                      <div class="timestamp">{{ formatReportDateTime(report.attend_time) }}</div>
                      <div class="name">{{ report.attendee_name }}</div>
                      <hr>
                        <div class="notes">{{ report.notes }}</div>
                        @if (report.images?.length) {
                          <div class="pictures">
                            @for (img of report.images; track $index) {
                              @if (img.url) {
                                <img src="{{img.url}}" alt="{{img.title}}" class="thumbnail"
                                  (click)="selectedImage = img.url" />
                              } @else {
                                <div class="spinner-border spinner-border-sm" role="status">
                                  <span class="visually-hidden"></span>
                                </div>
                              }
                            }
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
            }

            @if (showRouteSidebar) {
              <div class="rightsidebar route-sidebar">
                <div class="sidebarcontent">
                  <img src="assets/icons/close_red_24dp.svg" class="close-btn" (click)="closeSidebar()" />
                  <h2 class="title">{{ 'planner.routePlanning.route' | translate }}</h2>
                  <div>
                    <div class="route-info">
                      <div class="info-row">
                        <span class="label">ID:</span>
                        <span class="value">{{ selectedRoute?.id }}</span>
                      </div>
                      @if (selectedRoute?.identifier) {
                        <div class="info-row">
                          <span class="label">{{ 'planner.routePlanning.identifier' | translate }}:</span>
                          <span class="value">{{ selectedRoute?.identifier }}</span>
                        </div>
                      }
                      @if (selectedRoute?.notes) {
                        <div class="info-row">
                          <span class="label">{{ 'planner.routePlanning.notes' | translate }}:</span>
                          <span class="value">{{ selectedRoute?.notes }}</span>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }

            @if (showRouteNoteSidebar) {
              <div class="rightsidebar route-note-sidebar">
                <div class="sidebarcontent">
                  <img src="assets/icons/close_red_24dp.svg" class="close-btn" (click)="closeSidebar()" />
                  <h2 class="title">{{ 'planner.routePlanning.routeNote' | translate }}</h2>
                  <div>
                    <div class="route-note-info">
                      <div class="info-row">
                        <span class="label">ID:</span>
                        <span class="value">{{ selectedRouteNote?.id }}</span>
                      </div>
                      <div class="info-row">
                        <span class="label">{{ 'planner.routePlanning.route' | translate }} ID:</span>
                        <span class="value">{{ selectedRouteNote?.route_id }}</span>
                      </div>
                      <div class="notes-section">
                        <span class="label">{{ 'planner.routePlanning.notes' | translate }}:</span>
                        <p class="notes-text">{{ selectedRouteNote?.notes }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }

            @if (isLoading) {
              <div class="justify-content-center d-flex spinner">
                <load-spinner></load-spinner>
              </div>
            }
            <!-- Full-size Image Modal -->
            @if (selectedImage) {
              <div class="modal" (click)="selectedImage = null">
                <div class="modal-content" (click)="$event.stopPropagation()">
                  <span class="close" (click)="selectedImage = null">&times;</span>
                  <img [src]="selectedImage" class="image-size-full">
                </div>
              </div>
            }
          </div>

        </div>
        <!-- Project dashboard ends -->
